export enum OccursTimeType {
    Second = 0,
    Minutes = 1,
    Hour = 2,
}
